<script>

    import { toast } from 'bulma-toast'
    import { shipmentStore, tracingsStore, modalStore } from '../stores'
    
    import TracingsService from '../$services/tracings.service'

    import Title from '../$components/title.svelte'
    import Form from '../$components/form.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Button from '../$components/button.svelte'
    import Textarea from '../$components/textarea.svelte'

    let loading = false
    let data = {}

    async function createTracing() {

        data.shipmentId = $shipmentStore._id
    
        loading = true
        const resp = await TracingsService.createTracing(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tracingsStore.append(resp.data)
        data.comment = null
    }

</script>


<Title text="Crear seguimiento" />

<Form on:submit={createTracing} {loading}>

    <Textarea bind:value={data.comment} />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave />
    </div>
</Form>